module.exports = __webpack_public_path__ + "img/1526768442.bfcac21d.jpg";